import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["carouselInner"];

    openGallery(event) {
        const row = event.currentTarget.closest("tr");
        const feedbackId = row.dataset.feedbackId;
        const photos = JSON.parse(row.dataset.feedbackGalleryPhotos);

        // Очищаем карусель
        this.carouselInnerTarget.innerHTML = "";

        // Добавляем слайды для каждой фотографии
        photos.forEach((photoUrl, index) => {
            const isActive = index === 0 ? "active" : "";
            const slide = `
        <div class="carousel-item ${isActive}">
          <img src="${photoUrl}" class="d-block w-100" alt="Фотография отзыва ${feedbackId}">
        </div>
      `;
            this.carouselInnerTarget.insertAdjacentHTML("beforeend", slide);
        });

        // Открываем модальное окно
        const modal = new bootstrap.Modal(document.getElementById("galleryModal"));
        modal.show();
    }
}